import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getUserOptions = async (token, municipalityId) => {
  const url = `municipalities/${municipalityId}/user_options`
  const data = await apiGet({ url, token })
  return data
}

// Slim list of every non-system employee (id, external id, name, status,
// department) for select inputs — much lighter than the SOD-counts duties
// index.
export default function useUserOptions({ options } = {}) {
  const { municipality_id } = useContext(UserContext)
  const token = useContext(AuthContext)
  const queryFn = () => getUserOptions(token, municipality_id)
  return useQuery('user_options', queryFn, { ...options })
}
